// extracted by mini-css-extract-plugin
export default {"container":"Login_container__AfVl6","innerBox":"Login_innerBox__rMO6B","footer":"Login_footer__2h7V-","error":"Login_error__nSztd","or":"Login_or__aXlaf"};